import { QualifiedFeature } from "fe-common/graphql";

export type PanelResultEntry = { [panelId: string]: PatientPanelState };

export type PatientBackgroundInformation = {
  // We save for each panel what features were selected (so we could undo/restore)
  // and also if it was skipped we save "skip" in order for us to be able to show
  // the users that they clicked on "no"
  panelResults: PanelResultEntry;
};

export type PatientPanelState = {
  selectedFeatures: BackgroundFeature[];
  status: PanelQuestionStatus;
};

export type BackgroundFeature = {
  feature: QualifiedFeature;
  skipped?: boolean;
};

export enum PanelQuestionStatus {
  Initial, // Asks weather the user would like to add information regarding this panel
  Skipped, // If the user chose "NO" regarding adding the information
  Prompting, // User clicked "Yes" and did not select the features
  Answered, // User clicked "Yes" and finish selecting the panel features
}
